
export function News() {
  const recruitments = [
    {
      icon: 'ri-footprint-line',
      category: '大学祭コラボ',
      title: '「THE FLOOR」大学祭コラボダンスレッスンイベント',
      target: 'ダンスに強みのあるアイドル／アーティスト',
      description: '大学ダンスサークルとの共演型ダンスイベント。ワークショップ＋特典会＋大学祭コラボを実施し、若年層への認知拡大と"実力派"ブランディングを狙う拡張型プロジェクト。',
      mailSubject: '募集要項ダウンロード希望',
      mailBody: `募集要項のダウンロードを希望します。\n\n■お名前\n■メールアドレス\n■業種（例：芸能事務所 / メディア / イベント / 広告 / その他）\n\nもし可能でしたら、興味のある企画があれば教えてください。\n（例：THE FLOOR / ONE ACT / スポーツ企画 など）\n\nよろしくお願いいたします。`,
      status: 'download',
      color: 'from-blue-500 to-blue-600'
    },
    {
      icon: 'ri-basketball-line',
      category: 'スポーツ企画',
      title: '「THE GAME」アイドルグループ2組合同バスケ大会型ファンミ',
      target: '男性グループアイドル',
      description: '2組のグループによるエンタメ型バスケットボールイベント。ライブ披露・選手紹介・対戦企画を組み合わせ、パフォーマンス以外の魅力を可視化。スポーツ×アイドルの新しい話題創出企画。',
      mailSubject: '募集要項ダウンロード希望',
      mailBody: `募集要項のダウンロードを希望します。\n\n■お名前\n■メールアドレス\n■業種（例：芸能事務所 / メディア / イベント / 広告 / その他）\n\nもし可能でしたら、興味のある企画があれば教えてください。\n（例：THE FLOOR / ONE ACT / スポーツ企画 など）\n\nよろしくお願いいたします。`,
      status: 'download',
      color: 'from-orange-500 to-red-600'
    },
    {
      icon: 'ri-film-line',
      category: 'メディア型企画',
      title: '「ONE ACT」推し主演ショートドラマサブスク企画',
      target: '演技に挑戦したいアーティスト／俳優志望アイドル',
      description: 'SNS配信型のショートドラマシリーズ。縦型コンテンツ＋サブスク展開を想定し、物語とバラエティ通じてアーティストのブランド価値と継続的な接触機会を創出するメディア型企画。',
      mailSubject: '募集要項ダウンロード希望',
      mailBody: `募集要項のダウンロードを希望します。\n\n■お名前\n■メールアドレス\n■業種（例：芸能事務所 / メディア / イベント / 広告 / その他）\n\nもし可能でしたら、興味のある企画があれば教えてください。\n（例：THE FLOOR / ONE ACT / スポーツ企画 など）\n\nよろしくお願いいたします。`,
      status: 'download',
      color: 'from-indigo-500 to-indigo-600'
    },
    {
      icon: 'ri-goblet-line',
      category: '体験型イベント',
      title: '一夜スナックママ（仮）',
      target: '女性アイドル／アーティスト（ソロ・グループ）',
      description: 'アーティストが"一夜スナックママ"としてファンを迎える体験型イベント。トーク・限定パフォーマンス・参加型企画を通じて、距離の近い特別空間を創出。話題性とファンエンゲージメント向上を目的とした交流企画。',
      mailSubject: '募集要項ダウンロード希望',
      mailBody: `募集要項のダウンロードを希望します。\n\n■お名前\n■メールアドレス\n■業種（例：芸能事務所 / メディア / イベント / 広告 / その他）\n\nもし可能でしたら、興味のある企画があれば教えてください。\n（例：THE FLOOR / ONE ACT / スポーツ企画 など）\n\nよろしくお願いいたします。`,
      status: 'download',
      color: 'from-purple-500 to-purple-600'
    },
    {
      icon: 'ri-music-2-line',
      category: 'K-POPクラブイベント',
      title: 'K-POPクラブイベント（仮）',
      target: 'K-POPアイドル／K-POPパフォーマー',
      description: 'K-POPファンが集まるクラブイベント内でのライブ出演企画。既存ファン層への直接アプローチにより、新規獲得・認知拡大・SNS拡散を狙う実践型プロモーションイベント。',
      mailSubject: '',
      mailBody: '',
      status: 'coming-soon',
      color: 'from-pink-500 to-pink-600'
    },
    {
      icon: 'ri-heart-3-line',
      category: 'チャリティ企画',
      title: '「THE HOME」チャリティペット譲渡会',
      target: '動物愛護活動に関心のあるアーティスト',
      description: '保護犬・保護猫譲渡会とトークイベントを組み合わせたチャリティ企画。社会貢献とエンターテインメントを両立し、アーティストの社会的価値向上と新規層接点を創出。',
      mailSubject: '',
      mailBody: '',
      status: 'coming-soon',
      color: 'from-teal-500 to-teal-600'
    }
  ];

  const toEmail = 'ufirst2025@gmail.com';

  const buildMailtoLink = (subject: string, body: string) => {
    return `mailto:${toEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  return (
    <section id="news" className="py-16 md:py-24 bg-gradient-to-b from-black via-gray-900 to-black relative overflow-hidden">
      <div className="absolute top-1/4 right-0 w-48 md:w-72 h-48 md:h-72 bg-pink-500/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-1/4 left-0 w-48 md:w-72 h-48 md:h-72 bg-blue-500/10 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 md:px-6 py-2 rounded-full bg-gradient-to-r from-pink-500/20 via-purple-500/20 to-blue-500/20 border border-purple-500/30 text-purple-400 text-sm font-semibold tracking-wider mb-4 md:mb-6">
            RECRUITMENT
          </span>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-black text-white mb-4 md:mb-6" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
            出演者<span className="bg-gradient-to-r from-pink-400 via-purple-400 to-blue-400 bg-clip-text text-transparent">募集</span>
          </h2>
          <p className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto">
            あなたの魅力を、企画の力で"次のステージ"へ。<br />
            詳細は各募集要項をご確認ください。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {recruitments.map((item, index) => (
            <div
              key={index}
              className="group bg-gray-900/80 rounded-2xl md:rounded-3xl overflow-hidden border border-gray-800 hover:border-pink-500/30 transition-all duration-300 flex flex-col"
            >
              <div className={`h-2 bg-gradient-to-r ${item.color}`}></div>
              <div className="p-6 md:p-8 flex flex-col flex-1 gap-4 md:gap-6">
                <div className="flex items-center gap-3 md:gap-4">
                  <div className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl md:rounded-2xl bg-gradient-to-r ${item.color}`}>
                    <i className={`${item.icon} text-xl md:text-2xl text-white`}></i>
                  </div>
                  <span className="text-xs md:text-sm font-semibold text-gray-400 tracking-wider">{item.category}</span>
                </div>

                <div>
                  <h3 className="text-lg md:text-xl font-bold text-white mb-2">{item.title}</h3>
                  <div className="inline-flex items-center px-3 py-1 rounded-full bg-gray-800 text-xs md:text-sm text-gray-300">
                    <i className="ri-user-line mr-2"></i>
                    対象: {item.target}
                  </div>
                </div>

                <p className="text-gray-400 leading-relaxed text-xs md:text-sm flex-1">
                  {item.description}
                </p>

                <div className="mt-auto">
                  {item.status === 'download' ? (
                    <a
                      href={buildMailtoLink(item.mailSubject, item.mailBody)}
                      className={`inline-flex items-center justify-center w-full py-3 md:py-4 rounded-full bg-gradient-to-r ${item.color} text-white font-medium hover:shadow-lg hover:shadow-pink-500/20 transition-all whitespace-nowrap cursor-pointer text-sm md:text-base`}
                    >
                      <i className="ri-mail-send-line mr-2 text-base md:text-lg"></i>
                      募集要項を請求する
                    </a>
                  ) : (
                    <div className="inline-flex items-center justify-center w-full py-3 md:py-4 rounded-full bg-gray-800 border border-gray-700 text-gray-400 font-medium whitespace-nowrap text-sm md:text-base">
                      <i className="ri-time-line mr-2 text-base md:text-lg"></i>
                      Coming Soon...
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 md:mt-12 text-center">
          <p className="text-gray-500 text-xs md:text-sm">
            ※ ボタンをクリックするとメールアプリが開きます。送信後、担当者より募集要項をお送りします。
          </p>
        </div>
      </div>
    </section>
  );
}
